import { Graphics as PixiGraphics } from 'pixi.js';
export default class Graphics extends PixiGraphics {
  [propName: string]: any;
}
